import { inject, Injectable } from '@angular/core';
import { OrderProcessStatus } from '../order';
import { ActivityLogDbService } from './activity-log-db.service';
import { ActivityLog, PropertyPayload } from './activity-log.models';

@Injectable({ providedIn: 'root' })
export class ActivityLogService {
  private activityLogDbService = inject(ActivityLogDbService);

  /**
   * Get the last shipped date for an order by its ID looking into the activity logs related to that order.
   * @param orderId Order ID
   * @returns The date of the last shipped status change for the order
   */
  async getLastShippedDate(orderId: string): Promise<Date> {
    const logs = await this.activityLogDbService.getWhere({ where: { 'ref.id': orderId }, orderBy: [{ createdAt: 'desc' }] });
    const log = logs.find(item => {

      if (item.type !== 'property_changed') return false;

      const payload = item.payload as PropertyPayload;
      return payload?.changes[0]?.new === OrderProcessStatus.SHIPPED;
    });

    return log?.createdAt;
  }

  /**
   * Upsert an activity log entry in the database.
   * @param _data Activity log entry to upsert
   * @returns The ID of the upserted activity log entry
   */
  upsertActivityLog(_data: ActivityLog): Promise<string> {
    return this.activityLogDbService.upsert(_data);
  }
}
